<template>	
	<div>
			<div class="mfty-box">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Maob-EAM企业设备资产管理系统
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row" style="justify-content: space-between;">
						<img src="../../assets/img/EAMimg.png" />
						<div class="col" style="margin-left: 25px;justify-content: flex-start;">
							<div class="item-no" style="font-size: 24px;color: #000;">
								什么是Maob-EAM企业设备资产管理系统?
							</div>
							<div class="item-no" style="font-size: 16px;color: #696969;margin-top: 25px;line-height: 25px;text-align: left;">
								Maob-EAM (Enterprise Asset Management)企业资产管理系统, 主要包括：基础管理、工单管理、预防性维护管理、资产管理、作业计划管理、安全管理、库存管理、移动资产条码盘点、采购管理、报表管理、检修管理、数据采集管理等基本功能模块，以及工作流管理、电子看板等可选模块，可以实现：
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 有效了解公司资产的使用情况
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 降低设备故障率，提高设备可靠性
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 加强成本管理，降低总体维修及运营成本
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 细化、规范化管理，提高总体效率
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 减少设备停机时间,  增加设备使用效率
							</div>
						</div>
					</div>
				</div>
				
			</div>
			
			<div class="mfty-box" style="background-color: #f3f3f3;height: 700px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					车间管理常见问题
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row">
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon1.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								备管理依靠手工作业状态
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								容易发生疏漏造成管理损失
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon2.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								设备维修费用、设备故障停机损失
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								备品备件库存成本等维护管理成本居高不下
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon3.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								经常发生设备故障停机
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								造成极为严重的损失
							</div>
						</div>
					</div>
					<div class="row" style="margin-top: 60px;">
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon4.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								资源分配不合理，闲置物品较多
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								产权关系混乱,数量不清
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon5.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								购置上存在
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								很大的随意性
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon6.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								资产使用效率低
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								维护成本高昂
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="mfty-box" style="height: 750px;position: relative;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Maob-EAM系统核心功能
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div class="row ju-c al-c" style="position: absolute;top: 400px;">
					<div class="item ju-c">
						<img src="../../assets/img/leftArrow.png" @click="changeIndex" />
					</div>
					<div class="item-no" style="width: 1100px;"></div>
					<div class="item ju-c">
						<img src="../../assets/img/rightArrow.png"  @click="changeIndex"/>
					</div>
				</div>
				<div v-if="pageIndex==0" style="width: 1200px;margin: 0 auto;margin-top: 50px;position: relative;">
					<div style="background-color: #fff;width: 70px;top: 220px;left: 565px;height: 70px;border-radius: 50%;position: absolute;"></div>
					<div class="row" style="justify-content: space-between;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #0bcdcd;padding: 40px 50px;">
							 <div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								基本信息管理
							 </div>
							 <div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：<br>								记录设备台帐的基础信息,查看设备台账, 管理设备登记，设备转移调拨，查看设备日志和折旧信息详情。
							 </div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #20d29f;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								库存信息维护
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：<br>								设备备品备件出入库全流程管理，集成仓库管理系统，以实时数据制定库存补充计划，合理安排采购提前期。
							</div>
						</div>
					</div>
					<div class="row" style="justify-content: space-between;margin-top: 30px;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #ff9852;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								备品备件管理
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：<br>								提供备件相关基础数据的维护，备件计划管理，备件采购管理，备件仓储管理以及备件耗材管理，实现数字化。
							</div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #6f7af5;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								设备维护保养
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：<br>								管理设备报修，报修送审，分派人员，维修，审批成果，针对不同设备设置重要保养事项，有效预防故障发生。
							</div>
						</div>
					</div>
				</div>
				
				<div v-if="pageIndex==1" style="width: 1200px;margin: 0 auto;margin-top: 50px;position: relative;">
					<div style="background-color: #fff;width: 70px;top: 220px;left: 565px;height: 70px;border-radius: 50%;position: absolute;"></div>
					<div class="row" style="justify-content: space-between;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #0bcdcd;padding: 40px 50px;">
							 <div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								设备报废转让
							 </div>
							 <div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：<br>
								管理设备调拨转移，系统自动计算设备折旧信息，对超过使用期限或者状态不良的设备可进行处置报废。
							 </div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #20d29f;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								巡检和盘点
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：<br>
								发起巡检计划，分配人员，支持设备拍照上传，有效监控设备状态。设备进行在线盘点，盘点过程轻松便捷。
							</div>
						</div>
					</div>
					<div class="row" style="justify-content: space-between;margin-top: 30px;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #ff9852;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								统计分析报表
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：<br>
								系统对设备和备品自动生成详细的数据报表，统计简单方便，并可以根据需要选择网页、APP、电子看板等形式展。
							</div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #6f7af5;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								系统集成
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：<br>
								支持与ERP系统、MES系统、WES系统等第三方系统进行集成，实现数据互通共享，打破信息化孤岛。
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				curHeight: 0,
				pageIndex:0,
				index: 1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			changeIndex(){
				if(this.pageIndex==0){
					this.pageIndex=1
				}else{
					this.pageIndex=0
				}
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>


	.center-body {
		margin: 0 auto;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}

	.centerbtn {
		width: 240px;
		border-radius: 25px;
		background-color: #ff7e00;
		height: 50px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.com {
		font-size: 18px;
		color: #aaaaaa;
	}

	.active {
		color: #0070FD;
	}
</style>
